import React from 'react';
import { Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Slide, Button } from '@material-ui/core';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const PrivacyPolicyModal = ({ isOpen, handleClose }) => {
    return (
        <Dialog
            open={isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            fullWidth={true}
            maxWidth="md"
            disableScrollLock={true}
        >
            <DialogTitle disableTypography={true}>
                <Typography variant="h4">Solteq Oyj:n Ajoneuvokysely -palvelun tietosuojaseloste</Typography>
                {/* <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button> */}
            </DialogTitle>
            <DialogContent>
                <DialogContentText component="div">
                    <Typography variant="body1" paragraph>
                        Päivitetty 31.05.2024.
                    </Typography>
                    <Typography variant="h5">Rekisterinpitäjä</Typography>
                    <Typography variant="body1" paragraph>
                        Solteq Oyj, Revontulenkuja 1<br />
                        02100 Espoo
                    </Typography>
                    <Typography variant="h5">Rekisteristä vastaava yhteyshenkilö</Typography>
                    <Typography variant="body1" paragraph>
                        Tietosuojaan liittyvistä asioista Solteqilla vastaa tietosuojavastaava. Tietosuojaan liittyvät yhteydenotot voit osoittaa Solteqille
                        sähköpostitse: DPO@solteq.com ja puhelimitse: +358 (0)20 14444.
                    </Typography>
                    <Typography variant="h5">Rekisterin nimi</Typography>
                    <Typography variant="body1" paragraph>
                        Solteq Oyj:n Ajoneuvokysely -palvelu.
                    </Typography>
                    <Typography variant="h5">Oikeusperuste ja henkilötietojen käsittelyn tarkoitus</Typography>
                    <Typography variant="body1" paragraph>
                        Henkilötietojen käsittely perustuu rekisterinpitäjän sopimukseen asiakkaan kanssa palvelun tuottamiseksi asiakkaalle. Henkilötietojen käsittelyn
                        tarkoitus on tunnistaa palvelun käyttäjät ja tuottaa rekisterinpitäjälle tietoa palvelun käytöstä laskutusta varten. Tietoja ei käytetä
                        automatisoituun päätöksentekoon tai profilointiin.
                    </Typography>
                    <Typography variant="h5">Rekisterin tietosisältö</Typography>
                    <Typography variant="body1" paragraph>
                        Rekisteriin tallennettavia henkilötietoja ovat: henkilön nimi ja yritys/organisaatio.
                    </Typography>
                    <Typography variant="h5">Säännönmukaiset tietolähteet</Typography>
                    <Typography variant="body1" paragraph>
                        Rekisteriin tallennettavat tiedot saadaan asiakasyrityksen yhteyshenkilöltä.
                    </Typography>
                    <Typography variant="h5">Tietojen säännönmukaiset luovutukset ja tietojen siirto EU:n tai ETA:n ulkopuolelle</Typography>
                    <Typography variant="body1" paragraph>
                        Tietoja ei luovuteta säännönmukaisesti muille tahoille eikä EU:n tai ETA-alueen ulkopuolelle.
                    </Typography>
                    <Typography variant="h5">Rekisterin suojauksen periaatteet</Typography>
                    <Typography variant="body1" paragraph>
                        Rekisterin käsittelyssä noudatetaan huolellisuutta ja tietojärjestelmien avulla käsiteltävät tiedot suojataan asianmukaisesti tehokkain teknisin
                        ja organisatorisin toimenpitein. Henkilötietojen käsitteleminen on rajattu niihin henkilöihin, joille se on tarpeellista työtehtävien
                        suorittamisen kannalta, ja joita sitoo salassapitovelvollisuus..
                    </Typography>
                    <Typography variant="h5">Henkilötietojen säilytysaika</Typography>
                    <Typography variant="body1" paragraph>
                        Henkilötietoja säilytetään niin pitkään, kuin henkilöllä tai henkilön edustamalla yrityksellä on asiakassuhde rekisterinpitäjään. Henkilötiedot
                        poistetaan asiakassuhteen päättymisen jälkeen kohtuullisessa ajassa, ellei lainsäädännöstä muuta johdu.
                    </Typography>
                    <Typography variant="h5">Tarkastusoikeus ja oikeus vaatia tiedon korjaamista</Typography>
                    <Typography variant="body1" paragraph>
                        Jokaisella rekisterissä olevalla henkilöllä on oikeus tarkistaa rekisteriin tallennetut tietonsa ja vaatia mahdollisen virheellisen tiedon
                        korjaamista tai puutteellisen tiedon täydentämistä. Mikäli henkilö haluaa tarkistaa hänestä tallennetut tiedot tai vaatia niihin oikaisua, pyyntö
                        tulee lähettää kirjallisesti rekisterinpitäjälle. Rekisterinpitäjä voi pyytää tarvittaessa pyynnön esittäjää todistamaan henkilöllisyytensä.
                        Rekisterinpitäjä vastaa asiakkaalle EU:n tietosuoja-asetuksessa säädetyssä ajassa (pääsääntöisesti kuukauden kuluessa).
                    </Typography>
                    <Typography variant="h5">Muut henkilötietojen käsittelyyn liittyvät oikeudet</Typography>
                    <Typography variant="body1" paragraph>
                        Rekisterissä olevalla henkilöllä on oikeus pyytää häntä koskevien henkilötietojen poistamista rekisteristä. Niin ikään rekisteröidyillä on muut
                        EU:n yleisen tietosuoja-asetuksen mukaiset oikeudet kuten oikeus tietyissä tilanteissa pyytää henkilötietojen käsittelyn rajoittamista, vastustaa
                        henkilötietojen käsittelyä ja siirtää tiedot järjestelmästä toiseen. Pyynnöt tulee lähettää kirjallisesti (kuten sähköpostitse)
                        rekisterinpitäjälle. Rekisterinpitäjä voi pyytää tarvittaessa pyynnön esittäjää todistamaan henkilöllisyytensä. Rekisterinpitäjä vastaa
                        asiakkaalle EU:n tietosuoja-asetuksessa säädetyssä ajassa (pääsääntöisesti kuukauden kuluessa). Mikäli henkilö katsoo oikeuksiaan rikotun, on
                        hänellä oikeus tehdä valitus valvontaviranomaiselle, Suomessa tietosuojavaltuutetulle.
                    </Typography>
                    <Typography variant="h5">Huomioitavaa</Typography>
                    <Typography variant="body1" paragraph>
                        Ajoneuvokysely -palvelu hyödyntää asiakkaille Liikenne- ja viestintävirasto Traficomin tuottamaa liikenneasioiden rekisterin henkilötietoa, jonka
                        tietosuojaseloste on saatavilla osoitteessa:
                        <a rel="noreferrer noopener" target="_blank" href="https://www.traficom.fi/fi/traficom/tietosuoja-traficomissa/tietosuojaselosteet">
                            https://www.traficom.fi/fi/traficom/tietosuoja-traficomissa/tietosuojaselosteet
                        </a>
                    </Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Sulje
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PrivacyPolicyModal;
